<template>
  <div
    class="product-breadcrumbs"
    v-if="longestCategory && longestCategory.urlArray"
  >
    <nuxt-link :to="localePath('/')" class="product-breadcrumbs__breadcrumb">
      HOME |
    </nuxt-link>
    <nuxt-link
      v-for="(category, index) in longestCategory.urlArray"
      :key="`breadcrumb-${index}`"
      :to="regenerateCategoryUrlKey(category)"
      class="product-breadcrumbs__breadcrumb"
    >
      {{
        getCategoryName(regenerateCategoryUrlKey(category))
          ? `${getCategoryName(regenerateCategoryUrlKey(category))} ${
              index < longestCategory.urlArray.length - 1 ? '|' : ''
            }`
          : ''
      }}
    </nuxt-link>
  </div>
  <div v-else />
</template>

<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
// import {} from '@storefront-ui/vue';

export default defineComponent({
  name: 'ProductBreadcrumbs',
  components: {},
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const longestCategory = computed(() => {
      return props.product.categories
        ?.map((c) => ({
          urlArray: c.url_key.split('/'),
          name: c.name,
          url: c.url_key,
        }))
        .reduce((a, b) => (a.url.length > b.url.length ? a : b));
    });

    const getCategoryName = (urlKey) =>
      props.product?.categories?.find((c) => c.url_key === urlKey)?.name;

    const regenerateCategoryUrlKey = (lastUrlPart) =>
      longestCategory.value.urlArray.reduce((a, b) =>
        a === lastUrlPart ? a : a + '/' + b
      );

    return { longestCategory, getCategoryName, regenerateCategoryUrlKey };
  },
});
</script>

<style lang="scss">
.product-breadcrumbs {
  width: 100%;
  padding: 1.8125rem 0 0.5rem 0;
  &__breadcrumb {
    @include label-s;
    @include pointer;
    text-transform: uppercase;
    color: var(--c-black);
  }
}
@include from-desktop-min {
  .product-breadcrumbs {
    width: 50%;
  }
}
</style>
